import React from 'react';

import cn from 'classnames';

import { Flex, Skeleton } from '@shared/ui';

import cls from './WidgetShopSkeleton.module.css';

interface IWidgetShopSkeletonProps {
    className?: string;
}
export const WidgetShopSkeleton = ({ className }: IWidgetShopSkeletonProps) => (
    <Flex
        direction="column"
        align="start"
        gap={16}
        className={cn(cls.WidgetShopSkeleton, className)}
    >
        <Skeleton width={58} height={16} border="8px" />
        <div className={cls.listContainer}>
            <Skeleton height={96} border="8px" />
            <Skeleton height={96} border="8px" />
            <Skeleton height={96} border="8px" />
        </div>
    </Flex>
);
